import React from 'react';
import { motion } from 'framer-motion';
const CATEGORIES = [{
  title: 'Corporate Events',
  image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&w=800&q=80',
  desc: 'Elevate your brand with sophisticated corporate gatherings and galas.'
}, {
  title: 'Private Celebrations',
  image: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=800&q=80',
  desc: 'Intimate to grand scale private parties, meticulously planned.'
}, {
  title: 'Mixology Experiences',
  image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&w=800&q=80',
  desc: 'Interactive, high-end cocktail crafting and tasting sessions.'
}, {
  title: 'Gourmet Catering',
  image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=800&q=80',
  desc: 'Exquisite small chops and bespoke culinary journeys.'
}, {
  title: 'Brand Activations',
  image: 'https://images.unsplash.com/photo-1540039155732-d674d40d4e5f?auto=format&fit=crop&w=800&q=80',
  desc: 'Immersive pop-ups and brand experiences that leave a mark.'
}];
export function EventCategories() {
  return <section id="categories" className="w-full max-w-[95%] lg:max-w-[85%] mx-auto my-10 md:my-20" data-id="element-77">
      <div className="mb-12 md:mb-16 text-center" data-id="element-78">
        <span className="text-accent font-bold uppercase tracking-[0.35em] text-xs" data-id="element-79">
          Expertise
        </span>
        <h2 className="mt-4 text-white font-black uppercase tracking-tight text-3xl md:text-5xl" data-id="element-80">
          Curated Experiences
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-81">
        {CATEGORIES.map((cat, i) => <motion.div key={cat.title} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: i * 0.1
      }} className={`group relative overflow-hidden bg-black aspect-[4/5] ${i === 0 || i === 3 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-82">
            <img src={cat.image} alt={cat.title} className="absolute inset-0 h-full w-full object-cover opacity-60 transition-transform duration-700 group-hover:scale-110 group-hover:opacity-40" data-id="element-83" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" data-id="element-84" />

            <div className="absolute inset-0 p-8 flex flex-col justify-end" data-id="element-85">
              <h3 className="text-white font-black uppercase tracking-tight text-2xl md:text-3xl mb-3 transform transition-transform duration-500 group-hover:-translate-y-2" data-id="element-86">
                {cat.title}
              </h3>
              <div className="h-0 overflow-hidden opacity-0 transition-all duration-500 group-hover:h-auto group-hover:opacity-100 group-hover:mt-2" data-id="element-87">
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-88">
                  {cat.desc}
                </p>
                <span className="inline-block mt-4 text-accent text-xs font-bold uppercase tracking-widest" data-id="element-89">
                  Explore &rarr;
                </span>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}